import React from 'react';
import * as styles from '../styles/footer.module.css';

export default function Footer() {
  return (
    <section id="footer"
      className={"s-use py-1 text-center text-md-left " + styles.footer}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-4 px-4 py-4 py-md-0 text-md-left">

            <img src="https://firebasestorage.googleapis.com/v0/b/mercadeiro-896b2.appspot.com/o/misc%2Flogo_mercadeiro.svg?alt=media"
              alt=""
              className={"my-auto mr-auto " + styles.footerImg} />
          </div>

          <div className="col-12 col-md-4 px-4 my-2 py-md-0 text-center">
            <p className="fw-bold mb-0 o-50">Contato</p>
            <p className="mb-0">https://mercadeiro.conecdata.com.br</p>
            <p className="mb-0">
              <span className="icon-whatsapp o-50"></span>&nbsp;<strong className="rem-12">34 9 9972-4376</strong><br />
              <span className="icon-whatsapp o-50"></span>&nbsp;<strong className="rem-12">34 9 9192-9000</strong>
            </p>
          </div>

          <div className="col-12 col-md-4 px-4 py-4 py-md-0 text-md-right">
            <img src="https://firebasestorage.googleapis.com/v0/b/mercadeiro-896b2.appspot.com/o/misc%2Flogo_conecdata.svg?alt=media"
              alt=""
              className={"my-auto " + styles.footerImg} />
          </div>
        </div>

        <div className="row">
          <div className="col text-center p-4 o-50">
            Desenvolvido por Conecdata Sistemas - 2021 - CNPJ: 34.236.953/0001-75
          </div>
        </div>
      </div>
    </section>
  )
}